import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// ChannelTalk 초기화 - DOM ready 후 boot 실행
const channelTalkKey = import.meta.env.VITE_PUBLIC_CHANNELTALK_PLUGIN_KEY;
function bootChannelTalk() {
  if (!channelTalkKey) {
    console.warn('[ChannelTalk] 플러그인 키가 설정되지 않았습니다.');
    return;
  }
  if (!window.ChannelIO) {
    console.warn('[ChannelTalk] ChannelIO SDK가 로드되지 않았습니다.');
    return;
  }
  window.ChannelIO('boot', { pluginKey: channelTalkKey });
  console.log('[ChannelTalk] boot 완료');
}
// ChannelIO stub은 index.html의 인라인 스크립트에서 즉시 생성되므로
// DOMContentLoaded 전에도 window.ChannelIO는 존재함
if (window.ChannelIO) {
  bootChannelTalk();
} else {
  window.addEventListener('DOMContentLoaded', bootChannelTalk);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)